import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  output
} from "@angular/core";
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule
} from "@angular/forms";
import { NgxMaskDirective, OutputTransformFn } from "ngx-mask";

import { MatIconButton } from "@angular/material/button";
import { MatSuffix } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "app-text-box",
  templateUrl: "./text-box.component.html",
  imports: [
    ReactiveFormsModule,
    NgxMaskDirective,
    MatIconButton,
    MatSuffix,
    MatIcon
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextBoxComponent implements OnInit {
  type = input.required<"text" | "email" | "password" | "tel" | "number">();
  id = input<string | undefined>();
  parentForm = input.required<FormGroup<any>>();
  formControlKey = input.required<string>();
  placeholder = input<string | undefined>();
  maxLen = input<number | undefined>();
  clearable = input<boolean>(false);
  showBorder = input<boolean>(false);
  invalidText = input<string | undefined>();
  mask = input<string | undefined>();
  outputTransformFn = input<OutputTransformFn | undefined>();
  cleared = output<void>();

  confirm$ = output();

  constructor() {}

  ngOnInit(): void {}

  clear(): void {
    this.control.setValue("");
    if (this.cleared) {
      // TODO: The 'emit' function requires a mandatory void argument
      this.cleared.emit();
    }
  }

  confirm(): void {
    this.confirm$.emit();
  }

  get control(): AbstractControl {
    return this.parentForm().get(this.formControlKey());
  }

  validate(): void {
    if (!this.control.valid) {
      this.control.setErrors({ invalid: true });
    }
  }
}
